import React, { useState, useEffect, FC } from "react";
import MessageTextField from "./MessageTextField";
import { conversationsAtom, currentPageAtom, messageCountAtom } from "../store";
import { useAtom } from "jotai";
import MessageList from "./MessageList";
import { MdOutlineExpandLess, MdOutlineExpandMore } from "react-icons/md";
import useConversation from "../hooks/useConversation";

interface Props {
  messages: any[];
  isFetchingOlderConversations: boolean;
  setIsFetchingOlderConversations: React.Dispatch<
    React.SetStateAction<boolean>
  >;
}

const ConversationContainer: FC<Props> = ({
  messages,
  isFetchingOlderConversations,
  setIsFetchingOlderConversations,
}) => {
  const [openTextField, setOpenTextField] = useState(false);
  const [openConversation, setOpenConversation] = useState(true);
  const [conversations, setConversations] = useAtom(conversationsAtom);
  const [page, setPage] = useAtom(currentPageAtom);

  return (
    <div>
      <section className="con-container">
        <div
          className="con-heading-bx"
          onClick={() => {
            setOpenConversation(!openConversation);
            // reset page number so when opened, latest messages display
            setPage(1);
          }}
        >
          <p className="bold-text">Conversation</p>

          <div>
            <p className="">
              If you have questions or issues with this task,{" "}
              <b>engage with us in this section</b>
            </p>
            {openConversation && (
              <MdOutlineExpandLess size={30} color="#76808b" />
            )}
            {!openConversation && (
              <MdOutlineExpandMore size={30} color="#76808b" />
            )}
          </div>
        </div>

        {openConversation && (
          <div className="current-status-bx">
            <div className="conversation-container">
              <MessageList
                messageBox={{
                  open: openTextField,
                  setOpen: setOpenTextField,
                }}
                messages={messages}
                isFetchingOlderConversations={isFetchingOlderConversations}
                setIsFetchingOlderConversations={setIsFetchingOlderConversations}
              />
            </div>

            {openTextField && (
              <MessageTextField handleClose={() => setOpenTextField(false)} />
            )}
          </div>
        )}
      </section>
    </div>
  );
};

export default ConversationContainer;
